import { defineStore } from 'pinia';
import { qryUserQual } from '@tencent/wphk-act-base-cgi';
import { useConfigStore } from './config';
import { CustomException } from '@tencent/ppd-base-libs';

export const useStampStore = defineStore('stamp', {
  state: () => ({
    /** 已使用印花数 */
    userUsedCount: 0,
    /** 用户已获得印花资格数 */
    userTotalCount: 0,
  }),
  getters: {
    remainCount: (state) => state.userTotalCount - state.userUsedCount,
  },
  actions: {
    async qryUserQual() {
      try {
        // 从配置中获取信息
        const configStore = useConfigStore();
        const { stampId } = configStore.config.commonConfig.stampConfig;
        if (!stampId) throw new CustomException(stampId, 'eStampConfigStampIdEmpty', '新版狂赏印印花id为空');
        const stampIdDecodeVal = decodeURIComponent(stampId);

        const data = await qryUserQual({ qualId: stampIdDecodeVal });
        this.userUsedCount = data.usedCnt;
        this.userTotalCount = data.totalCnt;
      } catch (error) {
        throw error;
      }
    },
    updateUserQualLocal({ extraUsed }: {extraUsed: number}) {
      this.userUsedCount = Math.min(this.userTotalCount, this.userUsedCount + extraUsed) ;
    },
  },
});
